var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-10"},[_vm._v(" Create QR Code using this page "),_c('v-text-field',{attrs:{"outlined":""},model:{value:(_vm.qrCodeUrl),callback:function ($$v) {_vm.qrCodeUrl=$$v},expression:"qrCodeUrl"}}),_c('v-btn',{on:{"click":_vm.downloadQrCode}},[_vm._v("Download QR Code")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }